// ThankyouPage.tsx
import styles from "./styles.module.scss";
import appStore from "./assets/appstore.png";
// import playStore from "./assets/playstore.png";
import loginScreen from "./assets/login.png";
import loginScreenWalky from "./assets/loginWalky.png";
import button from "./assets/button.png";
import welcomeScreen from "./assets/image.png";
import welcomeScreenWalky from "./assets/imageWalky.png";
import { Button } from "@common/button";
import { OnboardingLayout } from "@common/onboardingLayout";
import { useEffect, useState } from "react";
import { getPaywallType } from "src/appConfig";

const APP_STORE_URL = "https://easyfitapp.onelink.me/9ZUp/ihdfsgus";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.fitness.easyfit";

const APP_STORE_URL_WALKY =
  "https://apps.apple.com/us/app/walky-walk-distance-tracker/id6751334380";

const EmailVersion = ({ isWalky }) => {
  return (
    <OnboardingLayout isWalky hideNavigateBack>
      <div
        className={`${styles.versionContainer} ${
          isWalky ? styles.walkyTheme : ""
        }`}
      >
        <h2>Thank you!</h2>
        <p className={styles.subtitle}>You can download the app</p>

        <div className={styles.step}>
          <div className={styles.stepNumber}>1</div>
          <p>
            <span>Download</span> the app using the link below
          </p>
          <a
            href={isWalky ? APP_STORE_URL_WALKY : APP_STORE_URL}
            className={styles.appStoreButton}
          >
            <img src={appStore} alt="Download on the App Store" />
          </a>
          {!isWalky && (
            <a href={PLAY_STORE_URL} className={styles.appStoreButton}>
              <img src={button} alt="Get it on Google Play" />
            </a>
          )}
        </div>

        <div className={styles.step}>
          <div className={styles.stepNumber}>2</div>
          <p>
            Tap "<span>Already have an account? </span>
            <span className={styles.link}> Log in</span>"
          </p>
          <img
            src={isWalky ? welcomeScreenWalky : welcomeScreen}
            alt="Login screen"
            className={styles.screenImageArrow}
          />
        </div>

        <div className={styles.step}>
          <div className={styles.stepNumber}>3</div>
          <p>
            Enter your <span>email</span> & <span>get the code</span>
          </p>
          <img
            src={isWalky ? loginScreenWalky : loginScreen}
            alt="Auth screen"
            className={styles.screenImage}
          />
        </div>
      </div>
    </OnboardingLayout>
  );
};

const AppStoreVersion = ({ isWalky }) => {
  const handleDownload = () => {
    window.open(isWalky ? APP_STORE_URL_WALKY : APP_STORE_URL);
  };

  return (
    <OnboardingLayout isWalky hideNavigateBack>
      <div
        className={`${styles.versionContainer} ${
          isWalky ? styles.walkyTheme : ""
        }`}
      >
        <h2>Thank you!</h2>
        <p className={styles.subtitle}>You can download the app</p>

        <div className={styles.step}>
          <div className={styles.stepNumber}>1</div>
          <p>
            <span>Download</span> the app using the link below
          </p>
          <a
            href={isWalky ? APP_STORE_URL_WALKY : APP_STORE_URL}
            className={styles.appStoreButton}
          >
            <img src={appStore} alt="Download on the App Store" />
          </a>
        </div>

        <div className={styles.step}>
          <div className={styles.stepNumber}>2</div>
          <p>
            Tap "<span>Already have an account? </span>
            <span className={styles.link}> Log in</span>"
          </p>
          <img
            src={isWalky ? welcomeScreenWalky : welcomeScreen}
            alt="Login screen"
            className={styles.screenImageArrow}
          />
        </div>

        <div className={styles.step}>
          <div className={styles.stepNumber}>3</div>
          <p>
            Enter your <span>email</span> & <span>get the code</span>
          </p>
          <img
            src={isWalky ? loginScreenWalky : loginScreen}
            alt="Auth screen"
            className={styles.screenImage}
          />
        </div>

        <div className={styles.action}>
          <Button
            variant={isWalky ? "walky" : undefined}
            onClick={handleDownload}
          >
            DOWNLOAD APP
          </Button>
        </div>
      </div>
    </OnboardingLayout>
  );
};

const PlayStoreVersion = ({ isWalky }) => {
  const handleDownload = () => {
    window.open(PLAY_STORE_URL);
  };

  return (
    <OnboardingLayout isWalky hideNavigateBack>
      <div
        className={`${styles.versionContainer} ${
          isWalky ? styles.walkyTheme : ""
        }`}
      >
        <h2>Thank you!</h2>
        <p className={styles.subtitle}>You can download the app</p>

        <div className={styles.step}>
          <div className={styles.stepNumber}>1</div>
          <p>
            <span>Download</span> the app using the link below
          </p>
          {!isWalky && (
            <a href={PLAY_STORE_URL} className={styles.appStoreButton}>
              <img src={button} alt="Get it on Google Play" />
            </a>
          )}
        </div>

        <div className={styles.step}>
          <div className={styles.stepNumber}>2</div>
          <p>
            Tap "<span>Already have an account? </span>
            <span className={styles.link}> Log in</span>"
          </p>
          <img
            src={isWalky ? welcomeScreenWalky : welcomeScreen}
            alt="Login screen"
            className={styles.screenImageArrow}
          />
        </div>

        <div className={styles.step}>
          <div className={styles.stepNumber}>3</div>
          <p>
            Enter your <span>email</span> & <span>get the code</span>
          </p>
          <img
            src={isWalky ? loginScreenWalky : loginScreen}
            alt="Auth screen"
            className={styles.screenImage}
          />
        </div>
        {!isWalky && (
          <div className={styles.action}>
            <Button
              variant={isWalky ? "walky" : undefined}
              onClick={handleDownload}
            >
              DOWNLOAD APP
            </Button>
          </div>
        )}
      </div>
    </OnboardingLayout>
  );
};

export const ThankyouPage = () => {
  const isWalky = getPaywallType().toLowerCase().includes("walky");
  const [platform, setPlatform] = useState("email");

  useEffect(() => {
    const userAgent = navigator.userAgent?.toLowerCase();
    if (/iphone|ipad|ipod|macintosh|mac os/.test(userAgent)) {
      setPlatform("ios");
    } else if (/android/.test(userAgent)) {
      setPlatform("android");
    } else {
      setPlatform("email");
    }
  }, []);

  if (isWalky) {
    return <AppStoreVersion isWalky={isWalky} />;
  }

  if (platform === "ios") return <AppStoreVersion isWalky={isWalky} />;
  if (platform === "android") return <PlayStoreVersion isWalky={isWalky} />;
  return <EmailVersion isWalky={isWalky} />;
};
